import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { IconScreen } from "@ucchub/ui";
import AlertNotification from "@vfuk/core-alert-notification";
import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";
import environment from "environment";
import type { ReactNode } from "react";

const ErrorBoundary = ({ children }: { children: ReactNode }) => (
  <ReactErrorBoundary
    fallbackRender={({ error }) => (
      <>
        {environment.isDevelopment && (
          <Spacing spacingLevel={{ top: 4, left: 8, right: 8 }}>
            <AlertNotification
              state="error"
              heading={{
                text: "Client-side Error (Development instance only):",
              }}
            >
              <Paragraph>{error.message}</Paragraph>
            </AlertNotification>
          </Spacing>
        )}

        <IconScreen
          title="The app has encountered an error."
          description="  Looks like the app crashed. You should contact your system
administrator."
          buttonOnClick={() => window.location.reload()}
          buttonText="Reload the app"
        />
      </>
    )}
  >
    {children}
  </ReactErrorBoundary>
);

export default ErrorBoundary;
